import moment from "moment"
import toast from "react-hot-toast"
import { logoutUser, logoutUserPotato } from "../apiCalls/authApi"

/***************************
 * Common Utilities
 ***************************/

export const refreshPage = () => {
  window.location.reload()
}

export const formatDecimal = (value) => {
  const numericValue = parseFloat(value)

  if (Number.isInteger(numericValue)) {
    return numericValue.toString()
  } else {
    return numericValue.toFixed(1)
  }
}

export const formatDateDigitsOnly = (date) => {
  if (date) {
    var stringDate = date.split("-")
    return stringDate[1] + "" + stringDate[2] + "" + stringDate[0]
  }
}

export function getCurrentDateTimeYYMMDDHHMMSS() {
  const currentDate = new Date()
  const year = String(currentDate.getFullYear()).slice(-4) // Extract last two digits of the year
  const month = String(currentDate.getMonth() + 1).padStart(2, "0") // Month starts from 0, so add 1, and pad with leading zero if necessary
  const day = String(currentDate.getDate()).padStart(2, "0") // Pad day with leading zero if necessary
  const hours = String(currentDate.getHours()).padStart(2, "0") // Pad hours with leading zero if necessary
  const minutes = String(currentDate.getMinutes()).padStart(2, "0") // Pad minutes with leading zero if necessary
  const seconds = String(currentDate.getSeconds()).padStart(2, "0") // Pad seconds with leading zero if necessary

  return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`
}

export const getTime = (date) => {
  return new Date(date).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
}

export const getTime12 = (date) => {
  return new Date(date).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
}

export const getMilitaryTime = (date) => {
  return new Date(date).toLocaleTimeString("it-IT", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    // hour12: true,
  })
}

export const formatTime = (time) => {
  var timeValue = time.split(":")
  // if (timeValue.length === 3) {
  var hour = parseInt(timeValue[0].trim())
  var hourSuffix = hour >= 12 ? "PM" : "AM"
  hour = hour % 12 || 12
  var formattedTime = ("0" + hour).slice(-2) + ":" + timeValue[1] + hourSuffix
  // }
  return formattedTime
}

export const numberWithCommas = (number) => {
  if (number) {
    const dec = parseFloat(number).toFixed(2)
    return dec.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0.0
  }
}

export const formatDateSeconds = (date) => {
  var formatDate = new Date(date)
  var stringDate = formatDate.toDateString().split(" ")

  return (
    stringDate[1] +
    " " +
    stringDate[2] +
    ", " +
    stringDate[3] +
    " " +
    formatDate.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1")
  )
}

export const subtractMonths = (numOfMonths, date = new Date()) => {
  date.setMonth(date.getMonth() - numOfMonths)
  return date.toISOString().split("T")[0]
}

export const getTodayDate = () => {
  return new Date()
}

export const startOfCurrentMonth = () => {
  const currentDate = new Date()
  currentDate.setDate(1)
  return currentDate
}

export const startOfMonth = (month) => {
  const date = moment(month, "MMMM")
  const startOfMonthDate = date.startOf("month").toDate()
  return startOfMonthDate
}

export const endOfMonth = (month) => {
  const date = moment(month, "MMMM")
  const endOfMonthDate = date.endOf("month").toDate()
  return endOfMonthDate
}

export const getSevenDaysAgo = () => {
  const sevenDaysAgo = new Date()
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)
  return sevenDaysAgo
}

export const getTodayDateISO = () => {
  let deets = new Date()
  let date = deets.toLocaleString("en-US", { timeZone: "Asia/Manila" })
  return moment(date).format("yyyy-MM-DD")
}

export const getTodayDateISOFormat = (dateparam) => {
  let deets = new Date(dateparam)
  let date = deets.toLocaleString("en-US", { timeZone: "Asia/Manila" })
  return moment(date).format("yyyy-MM-DD")
}

export const getAge = (dateString) => {
  var today = new Date()
  var birthdate = new Date(dateString)
  var age = today.getFullYear() - birthdate.getFullYear()
  var m = today.getMonth() - birthdate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
    age--
  }
  return age
}

export const formatDate = (date) => {
  if (date) {
    var stringDate = date.split("-")
    return stringDate[1] + "/" + stringDate[2] + "/" + stringDate[0]
  }
}
// export const formatDate = (date) => {
//     var formatDate = new Date(date);
//     var stringDate = formatDate.toDateString().split(" ");

//     return (
//         stringDate[1] +
//         " " +
//         stringDate[2] +
//         ", " +
//         stringDate[3] +
//         " " +
//         formatDate.toLocaleTimeString().replace(/(.*)\D\d+/, "$1")
//     );
// };

export const formatDateNoTime = (date) => {
  var formatDate = new Date(date)
  var stringDate = formatDate.toDateString().split(" ")
  // var withSlash = formatDate(stringDate);
  // //

  return stringDate[1] + " " + stringDate[2] + ", " + stringDate[3]
}

// example parameter: "2022-10-08 00:00:00"
export const formatDateSlash = (date) => {
  var stringDate = date.split(" ")
  var _cleaned = stringDate[0].split("-")

  return _cleaned[1] + "/" + _cleaned[2] + "/" + _cleaned[0]
}

export const formatMDY = (date) => {
  // //
  var stringDate = date.split("-")
  // //
  return stringDate[1] + "-" + stringDate[2] + "-" + stringDate[0]
}

export const validateUsername = (username) => {
  if (username === "") {
    return true
  } else {
    var filter =
      /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
    return String(username).search(filter) != -1
  }
}

export const isClosingTime = (time) => {
  var format = "hh:mm:ss"
  var endTime = moment(time, format)
  return moment().isAfter(endTime)
}

export const isNotClosingDate = (date) => {
  return moment().isBefore(moment(date).add(1, "d"))
}

export const validateContact = (num) => {
  var mobileFilter = /((^(\+)(\d){12}$)|(^\d{11}$))/
  var telFilter = /^[0-9]+(-[0-9]+)+$/

  if (
    String(num).search(mobileFilter) != -1 ||
    String(num).search(telFilter) != -1
  ) {
    return true
  } else {
    return false
  }
}

export const dateFormat = (date) => {
  return moment(date).format("MMM DD, YYYY")
}

export const formatYDM = (date) => {
  return moment(date).format("YYYY-MM-DD")
}

export const numberFormat = (data) => {
  return parseFloat(data).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
// export const numberFormat = (data) => {
//     if (typeof data === 'number') {
//         return data.toLocaleString(undefined, {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//         });
//     } else {
//         return false;
//     }
// };

export const antdesignSelectStyle = {
  color: "#5E5E5E", // Change color as needed
  textAlign: "left",
  fontFamily: "Gotham-Rounded-Medium",
}

export const numberFormatInt = (data) => {
  return parseFloat(data.replace(/,/g, ""))
}

export const formatNum = (num) => {
  return parseFloat(Math.round(num * 100) / 100).toFixed(2)
}

export const capitalizeFirstLetter = (string) => {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1)
  return null
}

export const TokenExpiry = async (error) => {
  if (error.error && (error.error.status === 401 || error.status === 401)) {
    logoutUser()
    logoutUserPotato()
    toast.loading("Token has expired. Logging you out...", {
      style: toastStyle(),
    })
    removeUserSession()
    setTimeout(() => refreshPage(), 1000)
  }
}

/***************************
 * Local Storage Utilities
 ***************************/

//return user data from local storage
export const getUser = () => {
  const userStr = localStorage.getItem("user")
  if (userStr) return JSON.parse(userStr)
  else return null
}

export const getUserId = () => {
  const userStr = localStorage.getItem("user")
  if (userStr) return JSON.parse(userStr)
  else return null
}

//return user name from local storage
export const getName = () => {
  const userStr = localStorage.getItem("name")
  if (userStr) return JSON.parse(userStr)
  else return null
}

export const getSignature = () => {
  const userStr = localStorage.getItem("signature")
  if (userStr) return JSON.parse(userStr)
  else return null
}

//return user type from local storage
export const getType = () => {
  const userStr = localStorage.getItem("type")
  if (userStr) return JSON.parse(userStr)
  else return null
}

//return user type from local storage
export const getBranchId = () => {
  const userStr = localStorage.getItem("branch_id")
  if (userStr) return JSON.parse(userStr)
  else return null
}

//return user role from local storage
export const getAPIKey = () => {
  const userStr = localStorage.getItem("api-key")
  if (userStr) return userStr
  else return null
}

//return token from local storage
export const getToken = () => {
  const userStr = localStorage.getItem("token")
  if (userStr) {
    try {
      return JSON.parse(userStr)
    } catch {
      return userStr
    }
  }
  return null
}

// POTATO CORNER -- return user role from local storage
export const getAPIKey2 = () => {
  const userStr = localStorage.getItem("api-key2")
  if (userStr) return userStr
  else return null
}

// POTATO CORNER -- return token from local storage
export const getToken2 = () => {
  const userStr = localStorage.getItem("token2")
  if (userStr) {
    try {
      return JSON.parse(userStr)
    } catch {
      return userStr
    }
  }
  return null
}

//remove user details from local storage
export const removeUserSession = () => {
  logoutUser()
  localStorage.removeItem("user")
  localStorage.removeItem("name")
  localStorage.removeItem("type")
  localStorage.removeItem("role")
  localStorage.removeItem("api-key")
  localStorage.removeItem("token")
}

export const isAdmin = () => {
  const accountType = getType()
  var is_admin = accountType === "admin" ? true : false
  return is_admin
}

// toast style
export const toastStyle = () => {
  return {
    fontFamily: "Gotham-Rounded-Medium",
    borderRadius: "10px",
    background: "#333",
    color: "#fff",
  }
}

export const selectDropdownStyle = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected ? "white" : "var(--primary-color)",
    borderRadius: "7px",
    border: "0px",
    minHeight: "20px",
    maxHeight: "35px",
  }),
  input: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isSelected ? "white" : "white",
  }),
  dropdownIndicator: (baseStyles, state) => ({
    ...baseStyles,
    color: "white",
  }),
  singleValue: (baseStyles, state) => ({
    ...baseStyles,
    color: "white",
  }),
  placeholder: (baseStyles, state) => ({
    ...baseStyles,
    color: "white",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected ? "var(--primary-color)" : "white", // Change background color when selected
    color: state.isSelected ? "white" : "black", // Change text color when selected
  }),
}

export const classificationOptions = [
  { name: "classification", label: "All Classification", value: "" },
  { name: "classification", label: "Ingredient", value: "ingredient" },
  { name: "classification", label: "Supplies", value: "supplies" },
  {
    name: "classification",
    label: "Cleaning Supplies",
    value: "cleaning_supplies",
  },
  {
    name: "classification",
    label: "Office Supplies",
    value: "office_supplies",
  },
  { name: "classification", label: "Equipment", value: "equipment" },
  { name: "classification", label: "Uniform", value: "uniform" },
  { name: "classification", label: "Beverage", value: "beverage" },
  { name: "classification", label: "Raw Material", value: "raw_material" },
  {
    name: "classification",
    label: "Store Supplies",
    value: "store_supplies",
  },
  {
    name: "classification",
    label: "Commissary Supplies",
    value: "commissary_supplies",
  },
  {
    name: "classification",
    label: "Commissary Equipment",
    value: "commissary_equipment",
  },
  {
    name: "classification",
    label: "Store Equipment",
    value: "store_equipment",
  },
  { name: "classification", label: "Carpentry", value: "carpentry" },
  { name: "classification", label: "Electrical", value: "electrical" },
  { name: "classification", label: "Painting", value: "painting" },
]
